import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Tue Jun 18 2019
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import moment from 'moment';
import { LoadingState } from '../../../../../shared/api/LoadingState';
import { getDateFormat } from '../../../../../shared/date/getDateFormat';
import logger from '../../../../../shared/logger';
import rootStore from '../../../../../shared/stores/RootStore';
import { StoreName } from '../../../../../shared/stores/StoreName';
import translate from '../../../../i18n/translate';
import Alert, { AlertType } from '../../../../info/Alert';
import Loader from '../../../../info/Loader';
import CellTooltip from './CellTooltip';

var ReleaseCRPPriceTooltip =
/*#__PURE__*/
function (_CellTooltip) {
  _inherits(ReleaseCRPPriceTooltip, _CellTooltip);

  function ReleaseCRPPriceTooltip() {
    var _this;

    _classCallCheck(this, ReleaseCRPPriceTooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseCRPPriceTooltip).apply(this, arguments));
    _this.competitorPriceStore = rootStore.getStore(StoreName.CompetitorPrice);
    _this.data = [];

    _this.setPageData = function (prices, zoneId) {
      // Destructuring Tooltip params
      var _this$props$colDef$to = _this.props.colDef.tooltipComponentParams,
          dataUploads = _this$props$colDef$to.dataUploads,
          competitorSites = _this$props$colDef$to.competitorSites; // Creating array of IPriceHistory

      _this.data = prices.map(function (price) {
        try {
          var competitorSite = competitorSites.get(price.siteId);
          var dataUpload = dataUploads.get(price.dataUploadId);

          var modifiedPrice = _this.competitorPriceStore.modifiedPrices.get(price.id);

          var priceHistoryIndex = _this.competitorPriceStore.priceHistoryIndexes.get(price.id);

          var priceType = price.flags.find(function (flag) {
            return flag.priceZoneId === zoneId;
          }).priceClassification();
          return Object.assign(Object.assign({
            competitorSite: competitorSite.externalId,
            competitorAddress: competitorSite.address,
            competitorCity: competitorSite.city,
            date: price.date.format(getDateFormat())
          }, dataUpload ? {
            researchType: dataUpload.researchType,
            agencyType: dataUpload.agencyType
          } : {}), {
            price: price.value.toFixed(2),
            priceChangeIndex: priceHistoryIndex && priceHistoryIndex.priceChangeIndex && priceHistoryIndex.priceChangeIndex.round(0).toNumber(),
            modifiedPrice: modifiedPrice && modifiedPrice.modifiedPrice.toFixed(2),
            priceType: priceType,
            promo: price.promo ? price.promo.toString() : 'false',
            sellout: price.sellout ? price.sellout.toString() : 'false'
          });
        } catch (e) {
          console.log(e);
          throw new Error(e);
        }
      }).sort(function (a, b) {
        var dateA = moment(a.date, getDateFormat());
        var dateB = moment(b.date, getDateFormat());
        return dateA.isBefore(dateB) ? 1 : dateA.isAfter(dateB) ? -1 : 0;
      });
    };

    _this.load = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var row, productId, colIdSplit, zoneId, competitorId, competitorPrices, priceIds;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Getting productId
                row = this.props.api.getDisplayedRowAtIndex(this.props.rowIndex);
                productId = row.data["ReleaseDetailCategory_productId"]; // Getting zoneId and competitorId

                colIdSplit = this.props.column.colId.split('_');
                zoneId = colIdSplit[1];
                competitorId = colIdSplit[2]; //

                /** Loading... */

                if (!(productId && competitorId && zoneId)) {
                  _context.next = 23;
                  break;
                }

                _context.prev = 6;
                _context.next = 9;
                return this.competitorPriceStore.getCompetitorPricesInZone(productId, zoneId, competitorId);

              case 9:
                competitorPrices = _context.sent;
                priceIds = competitorPrices.map(function (cP) {
                  return cP.id;
                });
                _context.next = 13;
                return Promise.all([this.competitorPriceStore.getModifiedPrices(priceIds), this.competitorPriceStore.getCompetitorPriceHistoryIndexes(priceIds, zoneId)]);

              case 13:
                this.setPageData(competitorPrices, zoneId);
                runInAction(function () {
                  return _this2.loadingState = LoadingState.Success;
                });
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](6);
                console.log(_context.t0);
                runInAction(function () {
                  return _this2.loadingState = LoadingState.Error;
                });

              case 21:
                _context.next = 24;
                break;

              case 23:
                logger.error('Some of Ids has not been found');

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 17]]);
      }));
    };

    return _this;
  }

  _createClass(ReleaseCRPPriceTooltip, [{
    key: "render",
    value: function render() {
      return this.loadingState === LoadingState.Pending ? React.createElement(Loader, null) : this.data != null && this.data.length > 0 ? React.createElement("table", {
        className: "table tooltip-crp"
      }, React.createElement("thead", null, React.createElement("tr", null, Object.keys(this.data[0]).map(function (k) {
        return React.createElement("th", {
          key: k
        }, translate("ReleasePriceHistory_".concat(k)));
      }))), React.createElement("tbody", null, this.data.map(function (d, i) {
        return React.createElement("tr", {
          key: i
        }, Object.values(d).map(function (v, j) {
          return React.createElement("td", {
            key: "".concat(i).concat(j)
          }, v);
        }));
      }))) : React.createElement(Alert, {
        type: AlertType.Info
      }, translate('message_no_price_history_found'));
    }
  }]);

  return ReleaseCRPPriceTooltip;
}(CellTooltip);

ReleaseCRPPriceTooltip = __decorate([observer], ReleaseCRPPriceTooltip);
export default ReleaseCRPPriceTooltip;